import { CoordinatorEventImpl } from '../../_types/events';

export class ConnectionGateManager {
  private currentPlayers = 0;
  private maxPlayers: number;

  public readonly events = {
    playerCountChanged: new CoordinatorEventImpl<{ currentPlayers: number; maxPlayers: number }>(),
  };

  constructor(maxPlayers: number) {
    this.maxPlayers = maxPlayers;
  }

  getCurrentPlayers(): number {
    return this.currentPlayers;
  }

  getMaxPlayers(): number {
    return this.maxPlayers;
  }

  canAcceptMore(): boolean {
    return this.currentPlayers < this.maxPlayers;
  }

  setMaxPlayers(maxPlayers: number): void {
    this.maxPlayers = maxPlayers;
    this.emitCountChanged();
  }

  onPlayerJoined(): void {
    this.currentPlayers++;
    this.emitCountChanged();
  }

  onPlayerLeft(): void {
    if (this.currentPlayers > 0) {
      this.currentPlayers--;
    }
    this.emitCountChanged();
  }

  onPlayerCountUpdated(count: number): void {
    this.currentPlayers = count;
    this.emitCountChanged();
  }

  reset(): void {
    this.currentPlayers = 0;
    this.emitCountChanged();
  }

  private emitCountChanged(): void {
    this.events.playerCountChanged.emit({
      currentPlayers: this.currentPlayers,
      maxPlayers: this.maxPlayers,
    });
  }
}
